import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { LabelMedium } from '../../../../../primitives/index.js';
export const TourOperator = ({
  tourOperator
}) => {
  return _jsx("div", {
    children: tourOperator.logo ? _jsx("img", {
      src: tourOperator.logo,
      alt: tourOperator.name
    }) : _jsx(LabelMedium, {
      children: tourOperator.name
    })
  });
};